// TopNavBar.jsx
import React from "react";
import { Button } from "antd";

const TopNavBar = () => {
    return (
        <div style={{
            // position: "fixed",
            // top: 0,
            width: "100%",
            backgroundColor: "#fff",
            borderBottom: "1px solid #f0f0f0",
            padding: "10px 24px",
            display: "flex",
            justifyContent: "space-between",
            zIndex: 999
        }}>
            <strong>Tarification ASSIGANTO AGRO</strong>
            <Button type="link" onClick={() => window.location.href = "/pricing"}>
                ← Revenir au choix
            </Button>
        </div>
    );
};

export default TopNavBar;
